module.exports = __webpack_public_path__ + "static/media/empty_products.868855af.png";